<template>
  <v-dialog
    :value="data !== null || id !== null"
    :transition="false"
    :max-width="800"
    :persistent="false"
    @click:outside="$emit('close')"
  >
    <FormInfoCategory
      v-if="data !== null || id !== null"
      :title="data.id ? 'Редактировать категорию' : 'Создать категорию'"
      :id="id"
      :data="data"
      :language="language"
      :info-categories="infoCategories"
      :loading="loading"
      :disabled="disabled"
      @cancel="$emit('close')"
      @language-update="updateLocaleHandler"
      @submit="submit"
    />
  </v-dialog>
</template>

<script>
import DialogAbstract from '@/components/abstract/dialog'
import FormInfoCategory from '@/pages/infoCategories/form'

export default {
  name: 'FormDialog',
  components: {
    FormInfoCategory
  },
  extends: DialogAbstract,
  props: {
    data: {
      type: Object,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    language: {
      type: String,
      default: null
    },
    infoCategories: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateLocaleHandler (value) {
      this.$emit('language-update', value)
    },
    submit (payload) {
      this.$emit('submit', payload)
    }
  }
}
</script>
